// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AD_INTERSTITIAL_SKIP_NOW = "Presko\u010d";
export const AD_INTERSTITIAL_SKIP_seconds = "Presko\u010d (%(seconds)s)";
